import { LatestNewsExpandedPopupInfoDto } from "../../../../networking/data/responses/latestnews/LatestNewsExpandedPopupInfoDto";
import { LatestNewsLandlordDto } from "../../../../networking/data/responses/latestnews/LatestNewsLandlordDto";
import { FinishedLeaderboardParticipantDto } from "../../../../networking/data/responses/leaderboard/FinishedLeaderboardParticipantDto";
import { RenterPolicyPenaltiesDto } from "../../../../networking/data/responses/renterPolicy/RenterPolicyPenaltiesDto";
import { RenterPolicyPenalties } from "../Renters/RenterPolicyPenalties";

export class LatestNewsExpandedPopupInfo {
    public readonly additionalPiggyBankTokensMultiplierPercentage?: number;
    public readonly initialRewardInTokens?: string;
    public readonly piggyMultiplier?: number;
    public readonly piggyClubMultiplier?: number;
    public readonly buildingLevel?: number;
    public readonly landlord?: LatestNewsLandlordDto;
    public readonly rewardInCoins?: number;
    public readonly penalties?: RenterPolicyPenaltiesDto;
    public readonly penaltiesCount?: number;
    public readonly leaderboardParticipants?: Array<FinishedLeaderboardParticipantDto>;

    public constructor(dto: LatestNewsExpandedPopupInfoDto) {
        this.additionalPiggyBankTokensMultiplierPercentage = dto.additionalPiggyBankTokensMultiplierPercentage ?? 0;
        this.initialRewardInTokens = dto.initialRewardInTokens ?? "0";
        this.piggyMultiplier = dto.piggyMultiplier ?? 0;
        this.piggyClubMultiplier = dto.piggyClubMultiplier ?? 0;
        this.buildingLevel = dto.buildingLevel;
        this.landlord = dto.landlord;
        this.rewardInCoins = dto.rewardInCoins;
        this.penalties = dto.penalties != undefined ? new RenterPolicyPenalties(dto.penalties) : null;
        this.penaltiesCount = dto.penaltiesCount;
        this.leaderboardParticipants = dto.leaderboardParticipants;
    }
}
